import React from "react";
import { about } from "../mock";
import Reveal from "./Reveal";

const About = () => {
  return (
    <section id="about" className="relative bg-white pt-10 md:pt-14 pb-20 md:pb-24 scroll-mt-24 md:scroll-mt-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="max-w-4xl">
          <Reveal>
            <p
              className="font-['Montserrat'] font-medium uppercase text-[#5AA84A] text-xs md:text-sm mb-8"
              style={{ letterSpacing: "0.18em" }}
            >
              {about.eyebrow}
            </p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-extrabold tracking-[-0.02em] leading-[1.05] text-neutral-900 text-4xl sm:text-5xl md:text-6xl">
              {about.titlePre}
              <span className="text-[#7B3FA7]">{about.titleAccent}</span>
            </h2>
          </Reveal>

          <div className="mt-12 space-y-7 font-['Montserrat'] font-normal text-neutral-500 text-base md:text-lg leading-relaxed">
            {about.paragraphs.map((p, i) => (
              <Reveal key={i} delay={160 + i * 80}>
                <p>{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={400}>
            <blockquote className="mt-12 border-l-[3px] border-[#7B3FA7] pl-6 md:pl-8">
              <p
                className="font-['Montserrat'] font-semibold text-black text-base md:text-lg leading-relaxed max-w-3xl"
              >
                {about.quote}
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
